import React from "react";

// Default rows
export const defaultBorrowerTypeRows = [
  {
    borrowerType: "Minority Borrowers",
    numberOfLoans: "",
    totalLoanValue: "",
    weightedAvgLTV: "",
  },
  {
    borrowerType: "All Other Borrowers",
    numberOfLoans: "",
    totalLoanValue: "",
    weightedAvgLTV: "",
  },
];

const BorrowerTypeTable = ({ borrowerTypeTable, setBorrowerTypeTable }) => {
  // Fallback to defaults; only write to state on change
  const safeTableData =
    Array.isArray(borrowerTypeTable) && borrowerTypeTable.length
      ? borrowerTypeTable
      : defaultBorrowerTypeRows;

  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...safeTableData];
    updated[rowIndex][field] = value;
    setBorrowerTypeTable(updated);
  };

  return (
    <div
      style={{
        marginTop: "16px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
        width: "100%",
        maxWidth: "none",
        marginInline: "auto",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "16px",
              }}
            >
              Borrower Type
            </th>
            <th style={tableHeaderStyle}>Number of Loans</th>
            <th style={tableHeaderStyle}>Total Loan Value</th>
            <th style={tableHeaderStyle}>Weighted Avg Loan-to-Value (%)</th>
          </tr>
        </thead>

        <tbody>
          {safeTableData.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "600",
                  paddingLeft: "16px",
                  backgroundColor: "#D3C9CE",
                  whiteSpace: "normal",
                }}
              >
                {row.borrowerType}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  inputMode="numeric"
                  value={row.numberOfLoans}
                  onChange={(e) =>
                    handleInputChange(index, "numberOfLoans", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  step="any"
                  value={row.totalLoanValue}
                  onChange={(e) =>
                    handleInputChange(index, "totalLoanValue", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  step="any"
                  min="0"
                  max="100"
                  value={row.weightedAvgLTV}
                  onChange={(e) =>
                    handleInputChange(index, "weightedAvgLTV", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (same as your reference tables)
const tableHeaderStyle = {
  padding: "20px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const inputStyle = {
  width: "95%",
  padding: "14px",
  height: "40px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default BorrowerTypeTable;
